import React from 'react';
import { graphql } from 'gatsby';
import ReferenceComponent from '../ReferenceComponent';
//@ts-ignore
import * as styles from './color-panel.module.css';
import { BrandColor } from '../../../types/KontentProps';
import { getColor } from '../Global/DataUtils';

interface Props {
    kontentItemId?: string;
    color: BrandColor;
    component: {
        value: {
            __typename: string;
            id: string;
            system?: { id?: string; type?: string; codename?: string };
            elements: {};
        }[];
    };
}

const ColorPanel: React.FC<Props> = (props) => {
    const component = props.component.value[0];
    const backgroundColor = getColor(props.color);

    const authorStyles = { backgroundColor: backgroundColor || '#fff' };
    const componentTypename: any = component?.__typename.replace(
        'kontent_item_',
        ''
    );
    return componentTypename ? (
        <section
            className={styles.wrapper}
            style={authorStyles}
            data-kontent-item-id={props.kontentItemId}
        >
            <ReferenceComponent
                name={componentTypename}
                kontentItemId={component?.system?.id}
                {...component?.elements}
            />
        </section>
    ) : null;
};

export default ColorPanel;

export const fragmentColorPanel = graphql`
    fragment ColorPanel on kontent_item_component___color_panel {
        elements {
            color {
                ...kontentColor
            }
            component {
                __typename
                ...kontentComponents
            }
        }
    }
`;
